import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=5551bb8d&scoped=true&"
import script from "./Bell.vue?vue&type=script&lang=js&"
export * from "./Bell.vue?vue&type=script&lang=js&"
import style0 from "./Bell.vue?vue&type=style&index=0&id=5551bb8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551bb8d",
  null
  
)

export default component.exports